import rootReducer, { RootState } from "./rootReducer";
import auth from "app/auth/store/auth.slice";
import userSetup from "app/user-setup/store/userSetup.slice";
import buscaDeInsumosApp from "app/main/insumos/store";
import trackingApp from "./trackingApp";
import {
  configureStore,
  Action,
  getDefaultMiddleware,
  ReducersMapObject,
  combineReducers,
  AnyAction,
} from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import thunk, { ThunkAction, ThunkDispatch } from "redux-thunk";
import { actionsApi } from "app/main/configuracoes/store/actionsApi";
import { insumosApi } from "app/main/insumos/store/actions";
// import logger from 'redux-logger';

const middleware: any = [
  ...getDefaultMiddleware({
    serializableCheck: false,
  })
    .concat(thunk)
    .concat(insumosApi.middleware)
    .concat(actionsApi.middleware),
];

export type IState = {};

export type IReducers = ReducersMapObject<IState>;
export type ILoadedState = Partial<IState>;
export type ILoadedReducers = Partial<IReducers>;

let asyncReducers: ILoadedReducers = {};

export const createRootReducer = (): any => {
  const initialReducers: ILoadedReducers = {
    auth,
    userSetup,
    trackingApp,
    buscaDeInsumosApp,
    ...asyncReducers,
    [actionsApi.reducerPath]: actionsApi.reducer,
    [insumosApi.reducerPath]: insumosApi.reducer,
  };
  return combineReducers(initialReducers);
};

if (process.env.NODE_ENV === "development") {
  const { createLogger } = require(`redux-logger`);
  const logger = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error,
  });

  middleware.push(logger);
}

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === "development",
  middleware,
});

export const injectReducer = (
  key: string,
  reducer: Partial<ReducersMapObject<IState, Action<any>>>
) => {
  asyncReducers[key] = reducer;
  if (store) {
    store.replaceReducer(createRootReducer());
    return store;
  }
};

setupListeners(store.dispatch);
export type ReduxState = ReturnType<typeof rootReducer>;
export type TypedDispatch = ThunkDispatch<ReduxState, any, AnyAction>;
export const useAppDispatch = () => useDispatch<TypedDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export default store;
